import { render, staticRenderFns } from "./Formalizacao.vue?vue&type=template&id=a686bb0c"
import script from "./Formalizacao.vue?vue&type=script&lang=js"
export * from "./Formalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports